import React, { useState } from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogComponent from "../../Shared/DialogComponent";
import DeliveryAddressSelect from "./DeliveryAddressSelect";
import styled from "styled-components";

const DeliveryDetailsSection = () => {
  const getExistingPincode = localStorage.getItem("pincode");
  const parsePincode = JSON.parse(getExistingPincode) || "";

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const userDetails = useSelector((state) => state.userDetails || {});
  const { userProfile = {}, isGuest = true } = userDetails;

  const userDefaultAddress = useSelector(
    (state) => state.userDetails?.defaultAddress || {}
  );

  const { fullName = "", address = {} } = userDefaultAddress;
  const {
    addressLine1 = "",
    addressLine2 = "",
    city = "",
    state = "",
    pinCode = "",
  } = address;
  const { contactDetails = [] } = userProfile;

  const handleChangeAddress = () => {
    console.log("Change Address Clicked");
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };
  const DailogTitle = "Select Delivery Address";

  const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: .8rem;
  font-family: 'Ancizar Sans', sans-serif;
  background-color:#fff;
  padding:.5rem 1rem;
  border: 1px solid rgb(34 34 34 / 12%);
  border-radius: 8px;
  margin-bottom: 1rem;
  min-width: 300px;
  position: relative;


  @media (max-width: 500px) {
width: 100%;
}

  .changeaddress{
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  color: rgb(69, 111, 23);
  font-size: 15px;
  font-family: 'Ancizar Sans', sans-serif;
  position: absolute;
 
 right:1rem;
 pdding:1rem;
 padding-top:0rem;



  }

  
  `

  const MainContainerTop = styled.div`
  display: flex;
  flex-direction:column;
  justify-content: flex-start;
  align-items: flex-start;
  
  font-size: 1rem;
  font-family: 'Ancizar Sans', sans-serif;
  width: 100%;

    `
    const MainContTop = styled.div`
      display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 1rem;
  font-family: 'Ancizar Sans', sans-serif;
    
    `
    const MainTypo = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: 'Ancizar Sans', sans-serif;
    font-weight: 500;

    `
    const UserContainer = styled.div`
      display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
  font-size: 1rem;
  font-family: 'Ancizar Sans', sans-serif;`


  const UserContainerText = styled.div`
  font-size: 14px;
  font-family: 'Ancizar Sans', sans-serif;
  font-weight: 500;
  margin-top: 5px;
  `
  const MainMIddle = styled.div`
      display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
  font-size: 1rem;
  font-family: 'Ancizar Sans', sans-serif;
  
  `

  return (
     <MainContainer>
      <MainContainerTop>
        {!isGuest?<>
         <MainContTop>
          <MainTypo>Deliver to</MainTypo>
         

         </MainContTop>
         <MainMIddle>
           <UserContainer>
            <UserContainerText>
              {`${fullName} , ${pinCode}`}
            </UserContainerText>
           
            
          </UserContainer>
         </MainMIddle>
        </>:<>
        <MainContTop>
          <MainTypo>Deliver to</MainTypo>
         
         
         
        </MainContTop>
         <MainMIddle>{`${parsePincode}`}</MainMIddle>
        </>

        }
         <div className="changeaddress" onClick={handleChangeAddress}>
        edit
       </div>
        <DialogComponent
                isOpen={isDialogOpen}
                isClose={handleDialogClose}
                Title={DailogTitle}
                body={
                  <DeliveryAddressSelect
                    DialogClose={handleDialogClose}
                    AddressList={contactDetails}
                    currentPincode={parsePincode}
                    isGuest={isGuest}
                  />
                }
              />

      </MainContainerTop>

      
       
      

     </MainContainer>
  );
};

export default DeliveryDetailsSection;
